import React, { Component } from 'react';
import { Table, Row, Button, DatePicker, message, Spin, } from 'antd';
import moment from 'moment';
import { dataDefaultYear, intervalData } from './data';
import imgSave from "../saveImg";
import Auth from "../Auth";
import TableText from "../TableText";
import "./index.scss";
import { calculation, getJson, numConvert, sum } from '@/method';
import FileSaver from "file-saver";

const { MonthPicker } = DatePicker;

Number.prototype.toFixed = function (exponent) {
    if (this > 0) {
        return parseInt(this * Math.pow(10, exponent) + 0.5) / Math.pow(10, exponent);
    } else {
        return parseInt(this * Math.pow(10, exponent) - 0.5) / Math.pow(10, exponent);
    }
}

class index extends Component {
    constructor(props) {
        super(props);
        this.state = {
            date: moment().format('D') <= 10 ?
                moment().subtract(2, 'month').format('YYYY-MM') :
                moment().subtract(1, 'month').format('YYYY-MM'),
            data: [],
            note: { note: "" },
            loading: true,
            loadingSave: false,
            print: false,
            isUpdate: false,
            dataAll: {}
        }
    }


    componentDidMount() {
        this.getData(this.state.date);
    }

    computeNum = (data, {
        sum1_1 = {},
        inter_sum1_1 = {},
        es1_1 = [],
        purchase = 0,
        es9_8_2,
        inter_purchase = 0,
    }) => {

        // 区域平台数据
        data[0].area = calculation(sum1_1['Rooms Revenue 客房收入'], sum1_1['Total Revenue 总收入'], 4).toFixed(3);
        data[1].area = calculation(sum1_1['F&B Revenue 餐饮收入'], sum1_1['Total Revenue 总收入'], 4).toFixed(3);
        data[2].area = calculation(sum1_1['Other Revenue 其他部门收入'], sum1_1['Total Revenue 总收入'], 4).toFixed(3);
        data[3].area = calculation(sum1_1["Rooms Dep't Profit 客房部门利润"], sum1_1['Rooms Revenue 客房收入'], 4).toFixed(3);
        data[4].area = calculation(sum1_1["F&B Dep't Profit 餐饮部门利润"], sum1_1["F&B Revenue 餐饮收入"], 4).toFixed(3);
        data[5].area = calculation(sum1_1["F&B Total Cost 食品及饮品成本"], sum1_1["F&B Revenue 餐饮收入"], 4).toFixed(3);

        data[6].area = calculation(sum1_1["Total Payroll Expense 人力资源总费用/薪酬及相关福利总费用"], sum1_1['Total Revenue 总收入'], 4).toFixed(3);
        data[7].area = calculation(sum1_1['Utility Cost 能源成本'], sum1_1['Total Revenue 总收入'], 4).toFixed(3);
        data[8].area = calculation(sum1_1["Other Expense and Cost 其他费用及成本"], sum1_1["Total Revenue 总收入"], 4).toFixed(3);
        data[9].area = numConvert(purchase).toFixed(3);

        // 收入区间
        data[0].interval = calculation(inter_sum1_1['Rooms Revenue 客房收入'], inter_sum1_1['Total Revenue 总收入'], 4).toFixed(3);
        data[1].interval = calculation(inter_sum1_1['F&B Revenue 餐饮收入'], inter_sum1_1['Total Revenue 总收入'], 4).toFixed(3);
        data[2].interval = calculation(inter_sum1_1['Other Revenue 其他部门收入'], inter_sum1_1['Total Revenue 总收入'], 4).toFixed(3);
        data[3].interval = calculation(inter_sum1_1["Rooms Dep't Profit 客房部门利润"], inter_sum1_1['Rooms Revenue 客房收入'], 4).toFixed(3);
        data[4].interval = calculation(inter_sum1_1["F&B Dep't Profit 餐饮部门利润"], inter_sum1_1["F&B Revenue 餐饮收入"], 4).toFixed(3);
        data[5].interval = calculation(inter_sum1_1["F&B Total Cost 食品及饮品成本"], inter_sum1_1["F&B Revenue 餐饮收入"], 4).toFixed(3);

        data[6].interval = calculation(inter_sum1_1["Total Payroll Expense 人力资源总费用/薪酬及相关福利总费用"], inter_sum1_1['Total Revenue 总收入'], 4).toFixed(3);
        data[7].interval = calculation(inter_sum1_1['Utility Cost 能源成本'], inter_sum1_1['Total Revenue 总收入'], 4).toFixed(3);
        data[8].interval = calculation(inter_sum1_1["Other Expense and Cost 其他费用及成本"], inter_sum1_1["Total Revenue 总收入"], 4).toFixed(3);
        data[9].interval = numConvert(inter_purchase).toFixed(3);

        // 本酒店数据
        data[0].hotel = calculation(getJson([5, 'year_actual'], es1_1), getJson([8, 'year_actual'], es1_1), 4).toFixed(3);
        data[1].hotel = calculation(getJson([6, 'year_actual'], es1_1), getJson([8, 'year_actual'], es1_1), 4).toFixed(3);
        data[2].hotel = calculation(getJson([7, 'year_actual'], es1_1), getJson([8, 'year_actual'], es1_1), 4).toFixed(3);
        data[3].hotel = numConvert(getJson([10, 'year_actual'], es1_1)).toFixed(3);
        data[4].hotel = numConvert(getJson([12, 'year_actual'], es1_1)).toFixed(3);
        data[5].hotel = numConvert(getJson([14, 'year_actual'], es1_1)).toFixed(3);

        data[6].hotel = numConvert(getJson([16, 'year_actual'], es1_1)).toFixed(3);
        data[7].hotel = numConvert(getJson([18, 'year_actual'], es1_1)).toFixed(3);
        data[8].hotel = numConvert(getJson([20, 'year_actual'], es1_1)).toFixed(3);
        data[9].hotel = numConvert(getJson([17, 'total_amount'], es9_8_2) / 100).toFixed(3);
        this.setState({
            data,
        }, () => {
            this.onSave();
        });
    }

    onChangeUpdate = (data) => {
        this.setState({ isUpdate: data });
    }

    onChange = (name, value, i) => {
        let data = this.state.data;
        data[i][name] = value;
        this.computeNum(data, this.state.dataAll);
    }

    // 获取表格5_6_1内容
    getData = (date) => {
        const dataBegin = JSON.stringify(dataDefaultYear);
        let data = JSON.parse(dataBegin);
        fetch(`/performanceYTDInfo?year=${moment(date).format('YYYY')}&month=${moment(date).format('M')}`, { credentials: 'include' }).then(x => x.json()).then(x => {
            if (x.data.data.length > 0) {
                data = x.data.data.sort((a, b) => a.sort - b.sort);
                // 使用固定的行业平均数据
                data = data.map((item, i) => ({ ...item, industry: dataDefaultYear[i].industry }));
            }

            if (x.data.es1_1 && x.data.es1_1.length > 0) {
                x.data.es1_1[11].year_actual = sum([x.data.extra_profit, x.data.es1_1[11].year_actual]);
                x.data.es1_1[12].year_actual = calculation(x.data.es1_1[11].year_actual, x.data.es1_1[6].year_actual, 3);
            }

            this.computeNum(data, x.data || {});
            this.setState({ loading: false, dataAll: x.data || {} });
        }).catch(err => {
            console.error(err);
            this.setState({ loading: false });
        })
    }
    // 保存表格5-6-1内容
    onSave = () => {
        this.setState({ loadingSave: true });
        let date = this.state.date;
        if (!date) {
            message.error('请选择年份月份');
            let timer = setTimeout(() => { this.setState({ loadingSave: false }); clearTimeout(timer) }, 1000)
            return
        }
        let year = moment(date).format("YYYY");
        let month = moment(date).format("M");
        let data = this.state.data.map(x => ({ ...x, year, month }));
        let dataFrom = new FormData();
        dataFrom.append('data', JSON.stringify(data));
        let headres = {
            method: 'post',
            credentials: 'include',
            headers: {},
            body: dataFrom
        }
        fetch('/performanceYTDAdd', headres).then(x => x.json()).then(x => {
            let timer = setTimeout(() => { this.setState({ loadingSave: false }); clearTimeout(timer) }, 1000)
            if (x.status == 1) {
                this.setState({ isUpdate: true });
                return
            }
            message.error(x.msg);
        }).catch(err => {
            let timer = setTimeout(() => { this.setState({ loadingSave: false }); clearTimeout(timer) }, 1000)
            console.error(err);
            message.error('保存失败' + JSON.stringify(err));
        })
    }

    onExpoetExcel = () => {
        this.setState({ print: true, loading: true }, () => {
            const name = `Performance Analysis 酒店经营情况分析 YTD ${this.state.date}`;
            const innerHtml = `
              <caption>${name}</caption>
              ${document.getElementById('table1').innerHTML.replace(/<table class="">/g, '<table border="1">')}
            `;

            var html = "<html><head><meta charset='utf-8' /></head><body>" + innerHtml + "</body></html>";
            var blob = new Blob([html], { type: "application/vnd.ms-excel" });
            FileSaver.saveAs(blob, `${name}.xls`);
            this.setState({ print: false, loading: false });
        });
    }

    downloadSG = () => {

        this.setState({ print: true, loading: true }, () => {
            imgSave('table6_3', 1.5, '6.20', this.state.date).then(x => {
                if (x.status == 1) {
                    message.info('添加成功！');
                } else {
                    message.error('添加失败' + x.msg);
                }

                this.setState({
                    print: false,
                    loading: false
                });
            }).catch(err => {
                console.error(err);
                this.setState({
                    print: false,
                    loading: false
                });
            })

        });
    }

    render() {
        const { data, print, date } = this.state;

        const columns = [{
            dataIndex: 'name',
            key: 'name',
            align: "center",
            width: 300,
            render: (text, record, index) => {
                if (new Date('2019-07').valueOf() > new Date(date).valueOf() && index >= 5 && index <= 10) {
                    return {
                        props: {
                            rowSpa: 0,
                            colSpan: 0
                        }
                    }
                }
                const props = {
                    text, index, type: 'text', name: "name", onChange: this.onChange,
                };

                return <TableText data={{ ...props }} />
            }
        }, {
            title: <div>Average Industry Performance Data <br /> 行业平均数据</div>,
            dataIndex: 'industry',
            key: 'industry',
            align: "center",
            width: 200,
            render: (text, record, index) => {
                if (new Date('2019-07').valueOf() > new Date(date).valueOf() && index >= 5 && index <= 10) {
                    return {
                        props: {
                            rowSpa: 0,
                            colSpan: 0
                        }
                    }
                }
                const props = {
                    text, index, type: "percent", name: "industry", onChange: this.onChange,
                    compared: {
                        title: ["Average Industry Performance Data <br /> 行业平均数据"],
                        record,
                        sqlName: "performance_ytd"
                    }
                };

                return <TableText data={{ ...props }} />
            }
        }, {
            title: <div>Average Area Performance Data<br /> 区域平均数据 <br /> {getJson(['hotel', 'area'], this.state.dataAll, "")}</div>,
            dataIndex: 'area',
            key: 'area',
            align: "center",
            width: 200,
            render: (text, record, index) => {
                if (new Date('2019-07').valueOf() > new Date(date).valueOf() && index >= 5 && index <= 10) {
                    return {
                        props: {
                            rowSpa: 0,
                            colSpan: 0
                        }
                    }
                }
                const props = {
                    text, index, type: 'percent', name: "area", onChange: this.onChange,
                    compared: {
                        title: ["Average Area Performance Data<br /> 区域平均数据"],
                        record,
                        sqlName: "performance_ytd"
                    }
                };

                return <TableText data={{ ...props }} />
            }
        }, {
            title: <div>Revenue Range (RMB) <br /> 收入区间 （单位：元）<br />{intervalData[getJson(['hotel', 'income_interval'], this.state.dataAll, "")]}</div>,
            dataIndex: 'interval',
            key: 'interval',
            align: "center",
            width: 200,
            render: (text, record, index) => {
                const props = {
                    text, index, type: 'percent', name: "interval", onChange: this.onChange,
                    compared: {
                        title: ["Revenue Range (RMB) <br /> 收入区间 （单位：元）"],
                        record,
                        sqlName: "performance_ytd"
                    }
                };

                return <TableText data={{ ...props }} />
            }
        }, {
            title: <div>Hotel Performance Data<br /> 本酒店数据</div>,
            dataIndex: 'hotel',
            key: 'hotel',
            align: "center",
            width: 200,
            render: (text, record, index) => {
                if (new Date('2019-07').valueOf() > new Date(date).valueOf() && index >= 5 && index <= 10) {
                    return {
                        props: {
                            rowSpa: 0,
                            colSpan: 0
                        }
                    }
                }
                const props = {
                    text, index, type: 'percent', name: "hotel", onChange: this.onChange,
                    compared: {
                        title: ["Hotel Performance Data<br /> 本酒店数据"],
                        record,
                        sqlName: "performance_ytd"
                    }
                };

                return <TableText data={{ ...props }} />
            }
        }];

        return (
            <Spin spinning={this.state.loading}>
                <div className="table7_1_1 style-center">
                    <Row className="title" id="table6_3"   >
                        <Row>1.1.2 YTD 年累计</Row>
                        <Row className="table-month">
                            <MonthPicker
                                placeholder="请选择年月"
                                monthCellContentRender={(date, local) => {
                                    return moment(date).format('M月')
                                }}
                                defaultValue={moment(this.state.date, "YYYY-MM")}
                                format="YYYY-MM"
                                onChange={(date, str) => {
                                    this.setState({
                                        date: str,
                                        data: [],
                                        loading: true,
                                        note: { note: "" }
                                    });
                                    this.getData(str)
                                }}
                            />
                        </Row>
                        <Table
                            columns={columns}
                            dataSource={data}
                            size="middle"
                            bordered
                            id="table1"
                            pagination={false}
                            className="content"
                            rowKey={(record, index) => index}
                        />
                    </Row>
                    <Auth loading={this.state.loading} auth="edit_6_2">
                        <Row className="table-footer-btn">
                            <Button
                                type="primary"
                                style={{ marginRight: 10 }}
                                onClick={() => {
                                    this.setState({ print: true }, () => {
                                        this.onExpoetExcel();
                                    });
                                }}
                            >导出Excel</Button>
                            {/* <Button
                                type="primary"
                                onClick={this.onSave}
                                loading={this.state.loadingSave}
                            >保存</Button> */}
                        </Row>
                    </Auth>
                </div>
            </Spin >
        );
    }
}

export default index;


// WEBPACK FOOTER //
// ./src/components/table/performanceAnalysis/YTD.js